module.exports = __webpack_public_path__ + "assets/img/block-right-hover-bb91b235.png";